import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

// LIST ALL campaignS
export const campaignList = (params = '') => Http.get(`/marketings${serialize(params)}`)
export const campaignCreate = (params = '') => Http.post('/marketings', params)
export const campaignByID = (params = '') => Http.get(`/marketings/${params}`)
export const campaignUpdate = (params = '') => Http.put(`/marketings/${params.id}`, params)
export const campaignDestroy = (params = '') => Http.delete(`/marketings/${params.id}`)
